import { useCallback } from "react";

import { ContentCard } from "cerulean";
import styles from "./CancelSubscriptionCard.module.scss";

interface CancelSubscriptionCardProps {
  subscriptionId: string;
  openCancelSubscriptionDialog: (subscriptionId: string) => void;
}

const CancelSubscriptionCard = ({
  subscriptionId,
  openCancelSubscriptionDialog,
}: CancelSubscriptionCardProps) => {
  const handleCancelSubscription = useCallback(() => {
    openCancelSubscriptionDialog(subscriptionId);
  }, [subscriptionId, openCancelSubscriptionDialog]);

  return (
    <ContentCard kind="button" onClick={handleCancelSubscription}>
      <div className={styles.container}>
        <div>
          <div className={styles.header}>Cancel subscription</div>
          <div className={styles.body}>
            {/* TODO: Replace with real subscription info */}
            {/* https://linear.app/narmi/issue/CDB-1044/integrate-the-api-subscriptions-and-merchant-info-removing-the-mock */}
            You could save $120/y if you cancel your Netflix subscription.
          </div>
        </div>
        <div className={styles.chevronContainer}>
          <span className="narmi-icon-chevron-right"></span>
        </div>
      </div>
    </ContentCard>
  );
};

export default CancelSubscriptionCard;
